import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { getLatestJob } from 'lib/selectors/getLatestJob';
import { getCurrentWorkOrderOp } from './getCurrentWorkOrderOp';
import { getPostLaborUpdatesOnNats } from './getPostLaborUpdatesOnNats';
import { getIsPausedSetup } from './getIsPausedSetup';

const getLatestJobName = createSelector(
  [
    getLatestJob,
    getCurrentWorkOrderOp,
    getPostLaborUpdatesOnNats,
    getIsPausedSetup,
  ],
  (latestJob, currentWorkOrderOp, natsFlowEnabled, isPausedSetup) => {
    // NATS flow: construct job name from work order op (except for paused setup)
    if (natsFlowEnabled && !isPausedSetup && currentWorkOrderOp) {
      const { partNumber, sequenceNumber, workOrderId } = currentWorkOrderOp;
      return `${partNumber || workOrderId} - Op ${sequenceNumber || ''}`.trim();
    }

    // Standard flow or paused setup: use job's display name
    return _get(latestJob, 'displayName', '');
  }
);

export { getLatestJobName };
